export default {"src":"/_next/static/media/SweepTrain.73c978ae.svg","height":150,"width":110,"blurWidth":0,"blurHeight":0};